export const fmtUSDT = (value) =>
  `${Number(value || 0).toLocaleString("en-US", {
    maximumFractionDigits: 4,
  })} USDT`;

export const fmtCurrency = (value, currency) =>
  `${Number(value || 0).toLocaleString("en-US", {
    maximumFractionDigits: currency === "NPR" ? 2 : 4,
  })} ${currency}`;

const nepalDateParts = () => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kathmandu",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  return Object.fromEntries(parts.map(({ type, value }) => [type, value]));
};

export const todayNepal = () => {
  const parts = nepalDateParts();
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const currentNepalMonth = () => {
  const parts = nepalDateParts();
  return `${parts.year}-${parts.month}`;
};

export const monthAdd = (yearMonth, amount) => {
  const [year, month] = yearMonth.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1 + amount, 1));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}`;
};

export const monthLabel = (yearMonth) => {
  const [year, month] = yearMonth.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, 1)).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
};

export const partyEntryOriginal = (entry) => ({
  currency: entry.currency || "USDT",
  amount: entry.amount_original ?? entry.amount_usdt,
  rate: entry.rate_per_usdt ?? 1,
});
